import { useSelector } from "react-redux";
import { useMemo } from "react";
import clsx from "clsx";
import { wrapper } from "../../redux";
import {
  fetchReviews,
  fetchRightNews,
  fetchVideos,
} from "../../redux/action-creaters/content";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import RightSide from "/components/layouts/rightSide";
import News from "../../components/side/news";
import styles from "./index.module.scss";
import Videos from "/components/side/videos";
import Redis from "/lib/redis";
import { Api } from "/api";
import pagesWrapper from "../../utils/pagesWrapper";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { checkIsBaltex } from "../../utils";
import BaltexReviews from "../../components/baltex/reviews";

export default function ReviewsPage({
  scripts,
  host,
  baltexReviews = [],
  isBaltex,
  isFarkop,
}) {
  const { reviews } = useSelector((state) => state.content);
  const { cityName } = useSelector((state) => state.location);

  const reviewsSorted = useMemo(() => {
    let sort = "PROPERTY_REGION_SORT_VALUE";
    if (cityName === "Москва") {
      sort = "PROPERTY_MSK_SORT_VALUE";
    } else if (cityName === "Санкт-Петербург") {
      sort = "PROPERTY_SPB_SORT_VALUE";
    }
    return reviews.sort((a, b) => {
      return parseInt(a[sort], 10) - parseInt(b[sort], 10);
    });
  }, [reviews, cityName]);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <RightSide
        side={
          <>
            {isFarkop && <Videos />}
            {isFarkop && <News />}
          </>
        }
        title="Отзывы"
      >
        {isBaltex && <BaltexReviews items={baltexReviews} />}
        {isFarkop && (
          <div className={clsx(isBaltex && styles.Baltex)}>
            {reviewsSorted.map((review) => (
              <>
                {review.PROPERTY_TYPE_VALUE === "Кнопка" && (
                  <a
                    href={review.PROPERTY_LINK_VALUE}
                    target="_blank"
                    rel="noreferrer"
                    key={review.ID}
                    className={styles.Button}
                  >
                    <div className={styles.Img}>
                      <img src={review.ICON_SRC} />
                    </div>
                    <div className={styles.Name}>{review.NAME}</div>
                    <div className={styles.Qnt}>
                      Количество отзывов: {review.PROPERTY_COUNT_VALUE}
                    </div>
                    <div className={styles.Rating}>
                      <div className="video-sources-block__rating-val">
                        {review.PROPERTY_RATING_VALUE}
                      </div>
                    </div>
                  </a>
                )}
                {review.PROPERTY_TYPE_VALUE === "Виджет" && (
                  <div className={styles.Item} key={review.ID}>
                    <h3>{review.NAME}</h3>
                    <div
                      className={styles.Frame}
                      dangerouslySetInnerHTML={{
                        __html: review["~PREVIEW_TEXT"],
                      }}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        )}
      </RightSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ req, query }) => {
    const data = {};
    const reset = Boolean(query.reset);
    const { host } = req.headers;
    if (checkIsBaltex(host)) {
      data.baltexReviews = await Api.baltex.getReviews(Redis, reset);
    }
    await store.dispatch(await fetchReviews(Redis));
    await store.dispatch(await fetchRightNews(Redis));
    await store.dispatch(await fetchVideos(Redis));
    store.dispatch(addBreadcrumb({ link: "/reviews/", name: "Отзывы" }));

    return pagesWrapper(
      data,
      store,
      Redis,
      {
        query,
        req,
      },
      "/reviews/",
    );
  };
});
